module.exports = __webpack_public_path__ + "static/media/mainPage3.2699499b.jpg";